<script lang="ts" setup>
import PackingSlipPackageTable from "@/data-views/tables/packing_slip_package/PackingSlipPackageTable.vue";
definePage({
  meta: {
    action: "read",
    subject: "PackingSlipPackage",
  },
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <PackingSlipPackageTable />
    </VCol>
  </VRow>
</template>

<style lang="scss">
@use "@core/scss/template/libs/apex-chart.scss";
</style>
